import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Modal, Col, ModalBody, ListGroup, ListGroupItem } from 'reactstrap';
import { SvgAssets } from '../../../assets/icons/iconSvg';
import c from '../../../constants/Colors';

const ModalCompatible = ({ dadComponent, texto }) => {
    console.log('modalCompatible', dadComponent)
    const VISIBLE = dadComponent.state.modalCompatible;
    const ITEMS = dadComponent.state.dataCompatible ?? [];
    const TOGGLE_MODAL = dadComponent['toggleModalCompatible'];
    return (
        <div>
            <Modal returnFocusAfterClose={false} isOpen={VISIBLE} toggle={() => TOGGLE_MODAL([])} className='modal_compatible' centered backdrop="static">
                <ModalBody>
                    <h6 className="title ">
                        Compatible
                    </h6>
                    <ListGroup flush className="list-group-desktop">
                        <div className='content-scroll'>

                            {
                                ITEMS.map((item, index) => {
                                    return (
                                        <ListGroupItem key={"v_" + index}>{item.submodelo}</ListGroupItem>
                                    )
                                })
                            }

                        </div>
                    </ListGroup>
                    <button
                        className="btn-block bg_verde"
                        type="button"
                        onClick={() => TOGGLE_MODAL([])}
                    >
                        CERRAR
                    </button>
                </ModalBody>
            </Modal>
        </div>
    )
}

export default ModalCompatible;